import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryState {
  failed: boolean;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("CHIN client crashed", error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-screen">
        <span className="wordmark">CHIN!</span>
        <h1>La mesa se desordenó.</h1>
        <p>Tu lugar sigue guardado. Recargá para volver a sentarte.</p>
        <button className="primary-button" type="button" onClick={() => window.location.reload()}>Recargar</button>
      </main>
    );
  }
}
